// extracted by mini-css-extract-plugin
module.exports = {"starWrapper":"_3nzz5g0whk-3Rm3s0SOr9w=="};